// extracted by mini-css-extract-plugin
export var printerCard = "_hi-1";
export var printerCardConfigured = "_hi-2";
export var printerCardError = "_hi-3";
export var printerCardsContainer = "_hi-0";
export var printerIcon = "_hi-8";
export var printerIconConfigured = "_hi-5";
export var printerIconContainer = "_hi-4";
export var printerIconError = "_hi-6";
export var printerIconUnconfigured = "_hi-7";
export var workstationsTableCard = "_hi-9";